module.exports = __webpack_public_path__ + "img/chase-mortensen.159f7c62.jpg";